export { ChineseWordsTrie, type KnownDatabaseWords } from "#chinese-words-trie";
export { getSentenceWords } from "#get-sentence-words";
export type { SentenceWord } from "#sentence-word";
export { useSentenceWords, type UseSentenceWordsResult } from "#use-sentence-words";
// The bare `queryFn` + key getter are exported alongside the hook so a caller that needs to segment
// text OUTSIDE a render (the speech drill resolves a transcript from a recognizer event) can go
// through the query client with the exact same key — sharing the cache rather than re-segmenting.
export {
  sentenceWordsQueryFn,
  useGetSentenceWordsQueryKey,
  useSentenceWordsQueryOptions,
} from "#use-sentence-words-query";
